/**
 * Sysadmin Platform — Tenants layout (Wave 1a / W1a-17 + W1a-18).
 *
 * Pure layout file with <Outlet /> so child routes (`tenants/index.tsx`
 * for the list, `tenants.$tenantId.tsx` for the detail) can mount.
 *
 * Why this exists separately: in TanStack file-based routing,
 * `tenants.tsx` is the parent of `tenants.$tenantId.tsx` (and of
 * `tenants/index.tsx`). If the parent renders its own UI without an
 * <Outlet />, the child route never mounts — the URL changes but the
 * page does not. The Playwright harness caught this on the first
 * "click row → detail" assertion (W1a-18 surface was unreachable).
 *
 * The list UI lives in `tenants/index.tsx`; the detail UI lives in
 * `tenants.$tenantId.tsx`. This file is just the bridge.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/tenants')({
  component: PlatformTenantsLayout,
});

function PlatformTenantsLayout() {
  return <Outlet />;
}
